@import './variables.scss';

zpr-dropdown.nav-dropdown {
  min-width: 1050px;

  .submenu-body-container {
    padding: 24px;
  }
  .submenu-list {
    p {
      margin-bottom: 0;
    }
    p.bold {
      margin-bottom: 8px;
    }
  }

  ul.submenu-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 40px;
    li {
      margin-bottom: 0;
      &::before {
          content: none;
          margin: 0;
      }
    }
  }
  .submenu-list-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    flex: 1;

    a:hover p {
      color: $hover-color;
    }
  }

  &[has-subnav] {
    .submenu-body-container {
      padding: 12px;
    }
    .submenu-list {
      display: flex;
    }
  }

  zpr-tabs-vertical [slot=tabs] p {
    word-break: unset;
  }
}

zpr-navbar-dropdown {
  .arrow-icon {
    width: 12px;
    height: 100%;
    margin-left: 5px;

    svg {
      stroke: $text-color;
      transition: $icon-transition;
    }

    &[data-opened="true"] svg{
      transform: rotate(180deg);
    }
  }

  a:hover {
    span:not(.indicator-icon) svg {
      stroke: $hover-color;
    }
  }
  a.btn {
    position: relative;
  }
  .indicator-icon {
    opacity: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    z-index: 7;
    width: 31px;
    height: 16px;
    background-image: url('data:image/svg+xml,<svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_640_3719)"><g filter="url(%23filter0_d_640_3719)"><path d="M13.7972 2.83577C14.595 1.72141 16.2518 1.72141 17.0496 2.83577L28.8468 19.3143H2L13.7972 2.83577Z" fill="white"/></g></g><defs><filter id="filter0_d_640_3719" x="-3" y="-2" width="36.8467" height="27.3142" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="2.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_640_3719"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_640_3719" result="shape"/></filter><clipPath id="clip0_640_3719"><rect width="31" height="16" fill="white"/></clipPath></defs></svg>');

    top: calc($navbar-height + 6px);
    transition: top calc($navbar-transition-time/2) ease-out;

    &[data-opened="true"]{
      opacity: 1;
      top: calc($navbar-height - 20px);
    }
  }


  a.btn[slot="toggle"] {
    padding: 16px 0;
  }

}

